<template>
  <div class="set-goal-button">
    <button v-if="role === 5" class="btn btn-primary btn-sm mr-3" @click.prevent="showGoalsModal('personal')">
      <i class="fa fa-bullseye"></i> Set Personal Goal
    </button>

    <div v-else class="dropdown">
      <button class="btn btn-primary btn-sm mr-3 dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fa fa-bullseye"></i> Set Goal
      </button>
      <div class="dropdown-menu">
        <a class="dropdown-item" href="#" @click.prevent="showGoalsModal('branch')">Branch Goals</a>
        <a class="dropdown-item" href="#" @click.prevent="showGoalsModal('personal')">Leader Goals</a>
      </div>
    </div>

    <set-branch-goals-modal v-if="role === 1" ref="setBranchGoalsModal" :role="role" />
    <set-personal-goals-modal ref="setPersonalGoalsModal" :role="role" />
  </div>
</template>

<script>
import SetBranchGoalsModal from "./modals/SetBranchGoalsModal.vue";
import SetPersonalGoalsModal from "./modals/SetPersonalGoalsModal.vue";

export default {
  name: 'SetupGoalsButton',
  components: {
    SetBranchGoalsModal,
    SetPersonalGoalsModal
  },
  props: {
    role: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      branches: [],
      consultants: []
    }
  },
  methods: {
    showGoalsModal(type) {
      if (type === 'branch') {
        this.$refs.setBranchGoalsModal.showModal = true;
      } else {
        this.$refs.setPersonalGoalsModal.showModal = true;
      }
    }
  }
}
</script>